import {
	DEFAULT_TIMELINE_FILTER,
	type TimelineFilterState,
} from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { isDocumentsOnlyActive } from "web_myplann/NotificationCenter/Utils/isDocumentsOnlyActive";

export const isTimelineFilterDefault = (
	value: TimelineFilterState,
	hasDocumentsFeature: boolean,
): boolean =>
	value.horizon === DEFAULT_TIMELINE_FILTER.horizon &&
	value.recentType === DEFAULT_TIMELINE_FILTER.recentType &&
	value.upcomingType === DEFAULT_TIMELINE_FILTER.upcomingType &&
	!isDocumentsOnlyActive(value.recentDocumentsOnly, hasDocumentsFeature) &&
	!isDocumentsOnlyActive(value.upcomingDocumentsOnly, hasDocumentsFeature);
